export default "assets/images/loader-b9d56beb.gif";